
import { Link } from 'react-router-dom';
import { CardInfo } from 'types/gameInfo';
import { LINK } from 'components/styles';
import { sanitizeURIPathSegment } from 'helpers/routing';

interface SetLinkProps {
  cardInfo: CardInfo | null;
  setName: string;
  onClick?: any;
}

const SetLink = ({cardInfo, setName, onClick = null} : SetLinkProps) => {
  if (!cardInfo?.gameCode && !cardInfo?.setName) {
    return <>{setName}</>;
  }

  return (
    <Link to={`/${cardInfo.gameCode}/${sanitizeURIPathSegment(cardInfo.setName)}`} onClick={onClick} className={LINK}>{setName}</Link>
  )
}

export default SetLink;